import React from 'react';
import {Drawer} from 'shared/ui/Drawer';
import type {ServiceSheetFields} from '../../model/types';

export type ServiceDetailsDrawerProps = {
	service: ServiceSheetFields | null;
	onClose: () => void;
};

function DetailBlock({
	label,
	value,
	spanFull,
	multiline,
}: {
	label: string;
	value: string;
	spanFull?: boolean;
	multiline?: boolean;
}): React.ReactElement {
	return (
		<div className={`flex min-w-0 flex-col gap-1.5 ${spanFull ? 'col-span-2' : ''}`}>
			<span className="text-sm leading-tight text-black/55">{label}</span>
			<span
				className={`text-base font-semibold leading-snug text-[#121212] ${
					multiline ? 'whitespace-pre-wrap break-words' : ''
				}`}
			>
				{value}
			</span>
		</div>
	);
}

export function ServiceDetailsDrawer({service, onClose}: ServiceDetailsDrawerProps): React.ReactElement | null {
	if (!service) {
		return null;
	}

	return (
		<Drawer open onClose={onClose} title={service.title} showCloseButton>
			<div className="grid min-h-0 grid-cols-2 gap-x-5 gap-y-5">
				<DetailBlock label="Кол-во" value={service.quantity} />
				<DetailBlock label="Ед. изм." value={service.unit} />
				<DetailBlock label="Цена" value={service.unitPrice} />
				<DetailBlock label="Стоимость" value={service.totalCost} />
				<DetailBlock label="Описание" value={service.description} spanFull multiline />
				<DetailBlock label="Адрес" value={service.address} spanFull multiline />
			</div>
		</Drawer>
	);
}
